import {Platform} from 'react-native';

const appIdentifier = 'com.diathrive.app.android';

// remove space & uppercase first letter and add rest unchanged
export function removeSpaceAndCaptalize(val) {
  var output = val.replace(/(\w+)(?:\s+|$)/g, function (_, word) {
    return word.charAt(0).toUpperCase() + word.substr(1);
  });

  return output;
}

export function getTestID(testID) {
  if (!testID) {
    return undefined;
  }

  const prefix = `${appIdentifier}:id/`;
  const hasPrefix = testID.startsWith(prefix);

  return Platform.select({
    android: !hasPrefix ? `${prefix}${testID}` : testID,
    ios: hasPrefix ? testID.slice(prefix.length) : testID,
    // need to add exact test id format for web
    web: testID,
  });
}

export const tID = getTestID;
